var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: "详情",
            visible: _vm.dialogShow,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            }
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.list.length },
              on: { click: _vm.exportdata }
            },
            [_vm._v("导出")]
          ),
          _c(
            "div",
            { staticClass: "radio-group-container" },
            [
              _c(
                "el-radio-group",
                {
                  staticClass: "horizontal-radio-group",
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.bagId,
                    callback: function($$v) {
                      _vm.bagId = $$v
                    },
                    expression: "bagId"
                  }
                },
                _vm._l(_vm.showItem, function(item, index) {
                  return _c(
                    "el-radio-button",
                    { key: index, attrs: { label: item } },
                    [_vm._v(_vm._s(item))]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading"
                }
              ],
              staticClass: "popover"
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.list, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "desc_name", label: "物品名称" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "desc_item_id", label: "物品ID" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "desc_num", label: "数量" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "quality", label: "品质列表" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(row.quality ? row.quality : "/") +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm.rawData.game_mark.indexOf("yjfm") > -1
                    ? [
                        _c("el-table-column", {
                          attrs: { prop: "equip", label: "是否装备" }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }